import { Component, Input, NgModule, OnChanges } from '@angular/core';

import { CommonModule } from '@angular/common';
import { WHideEmptyModule } from '@wipo/w-angular/directives';
import { toHeadingLevel, WHeadingLevel } from '@wipo/w-angular/shared';

@Component({
  selector: 'w-step',
  templateUrl: './w-step.component.html',
  standalone: false
})
/*
@id w-step
@name w-step
@status release
@description
*/
export class WStepComponent {
  @Input() title?: string;
  @Input() headingLevel: WHeadingLevel = 3; // title heading level 1-6 or 'h1'-'h6'
  @Input() collapsible = false; // allow to collapse the step
  @Input() collapsed = false; // show only issues
  @Input() modalStep = false; // @no-doc not supported
  @Input() stepTitleShortcut = false;
  @Input() disableUppercase = false; // @no-doc ULF no forcing uppercase
  @Input() reviewMode = false;
  @Input() isClose = false; // close to top navigation, no top margin
  @Input() contentStyle: Record<string, string> = {}; // override default content styling

  get toggleMatIcon() {
    return this.collapsed ? 'chevron_right' : 'expand_more';
  }
  get level() {
    return toHeadingLevel(this.headingLevel, 3);
  }
}
@NgModule({
  imports: [CommonModule, WHideEmptyModule],
  exports: [WStepComponent],
  declarations: [WStepComponent]
})
export class WStepModule { }
